import { Injectable } from '@angular/core';
import { Doenca } from '@tivic-team/manager-ts/dist/grl';
import { DoencaController } from 'app/controllers/grl/doenca.controller';
import { LoaderService } from '../loader.service';
import { DoencaSearch } from './doenca.search';

@Injectable()
export class DoencaService {

    constructor(
        private _doencaController: DoencaController,
        private _loaderService: LoaderService
    ) { }
    
    async find(doencaSearch?: DoencaSearch):Promise<Doenca[]>{
        try{return await this._doencaController.find(doencaSearch && doencaSearch.getFilters() || null);}
        catch(error){console.log(error); return [];}
    }

    async get(cdDoenca:number):Promise<any>{
        this._loaderService.show();
        return this._doencaController.get(cdDoenca).finally(() => this._loaderService.hide());
    }

}